import { Box } from "@mui/material"
import React, { PropsWithChildren } from "react"

export function CardScrim({ children }: PropsWithChildren) {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: {
          xs: "var(--spacing-tokens-size-in-px-spacing-spacing-xl)",
          sm: "var(--spacing-tokens-size-in-px-spacing-spacing-3xl)",
        },
        backgroundColor: "var(--call-scrim)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      {children}
    </Box>
  )
}
